import request from '@/utils/request'
import { getMemberShipTypeList } from '@/api/site'

function adminGetRefereeListFun(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeList.json',
    method: 'post',
    data
  })
}

export function adminGetAllRefereeList(data) {
  return new Promise((resolve, reject) => {
    adminGetRefereeListFun(data).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function adminGetRefereeList(data) {
  return new Promise((resolve, reject) => {
    getMemberShipTypeList().then(response => {
      const ret = response.data
      if (!ret.oldDataMode) {
        data.pass = 1
      } else {
        data.pass = 0
      }
      adminGetRefereeListFun(data).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  })
}

export function updatePlayerStatusAndMvp(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdatePlayerStatusAndMvp.json',
    method: 'post',
    data
  })
}

export function getRefereeInfo(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetReferee.json',
    method: 'post',
    data
  })
}

export function updateReferee(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateReferee.json',
    method: 'post',
    data
  })
}

export function UpdatePlayerGuardian(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateReferee.json',
    method: 'post',
    data
  })
}

export function AdminGetRefereeMatchList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeMatchList.json',
    method: 'get',
    params
  })
}
export function AdminGetRefereeGameList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeGameList.json',
    method: 'get',
    params
  })
}
export function AdminGetRefereeMatchList2(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeMatchList2.json',
    method: 'get',
    params
  })
}
export function AdminGetRefereeMatchTypeList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeMatchTypeList.json',
    method: 'get',
    params
  })
}
export function AdminUpdateGameRefereePerformances(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateGameRefereePerformances.json',
    method: 'post',
    params
  })
}
export function ExportRefereeYearsData(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/ExportRefereeYearsData.json',
    method: 'post',
    params
  })
}
export function AdminGetRefereeYearsData(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetRefereeYearsData.json',
    method: 'get',
    params
  })
}
export function AdminImportRefereeTrainingData(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminImportRefereeTrainingData.json',
    method: 'post',
    params
  })
}
